import { Button } from 'antd';
import { useCallback, useEffect, useRef, useState } from 'react';
import List from 'src/components/grid.component/index'
import { AddresssHandler, CreditHandler, DateHandler, TransactionHash } from './service';
import EnergyTransactions from './energyTransactions';
import { useParams } from 'react-router-dom';

const RecentEnergyTransactions = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { tenantId } = useParams()
  const gridRef = useRef(null);
  const { isEnergyRechargeGridRefresh, setIsEnergyRechargeGridRefresh } = props?.GridRefreshData;
  useEffect(() => {
    gridRef?.current?.refreshGrid();
    setIsEnergyRechargeGridRefresh(false);
  }, [isEnergyRechargeGridRefresh]);

  const showModal = useCallback(() => {
    setIsModalVisible(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsModalVisible(false);
  }, [])
  const handleHash = useCallback((data) => () => {
    window.open(data.url)
  }, [])
  const energyTransactionHandler = useCallback((data) => {
    return <TransactionHash data={data?.dataItem} handleHash={handleHash} />
  }, [])
  const addressHandler = useCallback((data) => {
    return <AddresssHandler data={data?.dataItem} />
  }, [])
  const creditHandler = useCallback((data) => {
    return <CreditHandler data={data?.dataItem} />
  }, [])
  const dateHandler = useCallback((data) => {
    return <DateHandler data={data?.dataItem} />
  }, [])
  const gridColumns = [
    {
      "field": "address",
      "title": "Address",
      "filter": true,
      "customCell": addressHandler,
      "width": 200,
    },
    {
      "field": "credits",
      "title": "Credit Used",
      "customCell": creditHandler,
      "filter": true,
      "width": 150,
      "filterType": "numeric"
    },
    {
      "field": "transactionhash",
      "title": "Transaction Hash",
      "filter": true,
      "customCell": energyTransactionHandler,
      "width": 200,
    },
    {
      "field": "date",
      "title": "Date/Time",
      "filter": true,
      "width": 200,
      "filterType": "date",
      "customCell": dateHandler,
    }
  ]
  return (
    <div className='mt-5'>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h2 className="main-title text-capitalize">
          Recent Energy Used Transactions
        </h2>
        <Button type="default" className="cancel-btn !px-4 !py-1 !h-auto" onClick={showModal}>
          See All
          <span className="icon icon-arrow-right ml-2"></span>
        </Button>
        {isModalVisible && <EnergyTransactions visible={isModalVisible} onClose={handleClose} />}
      </div>

      <List
        url={process.env.REACT_APP_API_END_POINT + `/api/v1/energy/transactions/${tenantId}/null/null/null`}
        pSize={5}
        className="custom-grid"
        pageable={false}
        screenName={'Energy_Recharge_Transactions'}
        columns={gridColumns}
        ref={gridRef}
      />
    </div>
  );
};
export default RecentEnergyTransactions;